// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2008":"ee08c8b9","3628":"32cfde0d","9627":"ee08c8b9"}[chunkId] + ".chunk.css";
};